import { atom } from 'recoil';

const loading = atom({
    key:"loading",
    default:false
});

const selectedMenu = atom({
    key:"selectedMenu",
    default:"Dashboard"
});

const isAdmin = atom({
    key:"isAdmin",
    default:false
});

const activeSubmit = atom({
    key:"activeSubmit",
    default:false
});

const fireSubmit = atom({
    key:"fireSubmit",
    default:false
})

const publishState = atom({
    key:"publishState",
    default:{
        publishDateTime:null
    }
});

const subMenuState = atom({
    key:"subMenuState",
    default:""
});

const instructorApp = atom({
    key:"instructorApp",
    default:null
});

const userInfo = atom({
    key:"userInfo",
    default:null
})

const Alert = atom({
    key:"alertMessage",
    default:{
        isActive:false,
        text:"Alert Title",
        desc:"text",
        type:"info",
        color:"blue",
        time:1200
    }
})
const RequestedData = atom({
    key:"RequestedData",
    default:[
        {
            id:1,
            tag:"NEW",
            coachingId:1006,
            coachingTypeId:1010,
            title:"How to Enhance Your Entrepreneurship",
            file:null,
            request:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto blanditiis consequuntur corporis expedita," +
                " illo impedit iure libero magnam nam nesciunt nobis obcaecati pariatur possimus quaerat quam quasi quis repudiandae temporibus?",
            solutionType:"ADVICE",
            userType:"He/Him",
            target:"MYSELF",
            toName:"student",
            progress:"IN_PROGRESS",
            contentType: "CLASSIC",
            is24hr:true,
            answer:"",
            uploadFile:null,
            accepted:false,
            updatedDatetime:[2024, 1, 1, 17, 2, 1, 474608000],
        },
        {
            id:2,
            tag:"NEW",
            coachingId:1006,
            coachingTypeId:1011,
            title:"How to Enhance Your Entrepreneurship",
            file:null,
            request:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto blanditiis consequuntur corporis expedita," +
                " illo impedit iure libero magnam nam nesciunt nobis obcaecati pariatur possimus quaerat quam quasi quis repudiandae temporibus?",
            solutionType:"OTHER",
            userType:"She/Her",
            target:"SOMEONE_ELSE",
            toName:"student",
            progress:"IN_PROGRESS",
            contentType: "VIDEO",
            is24hr:false,
            answer:"",
            uploadFile:null,
            accepted:false,
            updatedDatetime:[2024, 1, 1, 17, 2, 1, 474608000]
        }
    ]
})

export {
  activeSubmit,
  fireSubmit,
  instructorApp,
  isAdmin,
  loading,
  publishState,
  selectedMenu,
  subMenuState,
  userInfo,
  RequestedData,
  Alert
};